import { FC, useEffect, useState } from 'react'
import moment from 'moment'
import { Box, Typography } from '@mui/material'
import { flexrow } from '../../global'
import { EventType } from './EventType'
import { ActionMenus } from '../ActionMenus/ActionMenus-EventCard'
import { useStyles } from './styles'
import { IconCustom } from '../IconCustom/IconCustom'
import { BadgeStatus } from '../BadgeStatus/BadgeStatus'
import { BadgeEventFlag } from '../BadgeEventFlag/BadgeEventFlag'
import { CalendarEventDataInterface } from '../EtaCalendar/EtaCalendar'
import { CalendarEventQueueInterface } from '../../pages/EtaCalendar/EtaCalendarPage'
import { EventDetailsPopup } from '../EtaCalendar/EventDetailsPopup'

let user: any = localStorage.getItem('user')
if (user) user = JSON.parse(user)

export interface EventCardProps {
  data: CalendarEventQueueInterface
  onCancelEvent: (id: number) => void
  onRevertEvent: (id: number) => void
}

export const EventCard: FC<EventCardProps> = ({
  data,
  onCancelEvent,
  onRevertEvent,
}) => {
  const classes = useStyles();
  const [openEventDetails, setOpenEventDetails] = useState(false)
  const [eventDetailsData, setEventDetailsData] = useState<CalendarEventDataInterface>({} as CalendarEventDataInterface)

  useEffect(() => {
    // temporarily convert CalendarEventQueueInterface to CalendarEventDataInterface
    let eventDetailsData: CalendarEventDataInterface = {
      ...data,
      start: new Date(data.date),
      end: new Date(data.date),
      startString: moment(data.date).format('ddd MMM DD, YYYY'),
      endString: moment(data.date).format('ddd MMM DD, YYYY'),
      startTime: data.time,
      endTime: '',
      category: data.eventType
    };
    setEventDetailsData(eventDetailsData)
  }, [data])

  return (
    <Box className={classes.eventCardBox}>
      <Box style={flexrow}
        gap='8px'
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '2px solid #F3F3F7',
          padding: '6px 16px 4px 16px'
        }}
      >
        <Box style={flexrow} sx={{ alignItems: 'center' }} gap='8px'>
          <IconCustom
            type={data.eventType}
            marginRight="8px"
          />
          <Typography className={classes.dateText}>
            {data.date}
          </Typography>
          <Typography className={classes.timeText}>
            {data.time}
          </Typography>
        </Box>
        <ActionMenus
          data={data}
          onCancelEvent={onCancelEvent}
          onRevertEvent={onRevertEvent}
        />
      </Box>
      <Box
        onClick={() => {
          setOpenEventDetails(true)
        }}
      >
        <Box className={classes.textBox}>
          <Typography className={classes.titleText}>
            {data.title}
          </Typography>
        </Box>

        <Box
          style={flexrow}
          alignItems='center'
          justifyContent='space-between'
          sx={{
            padding: '4px 16px 6px 16px'
          }}
        >

          {user ? (
            <Box style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              <Box style={{ display: 'flex', flexDirection: 'row', gap: '6px' }}>
                <BadgeStatus status={data.status} />
              </Box>
              <Box style={{ display: 'flex', flexDirection: 'row', gap: '6px' }}>
                {data.seriesId > 0 && (
                  <BadgeEventFlag label="Series" />
                )}
                {data.dryRun && (
                  <BadgeEventFlag label="Dry Run" />
                )}
              </Box>
            </Box>
          ) : (
            <EventType eventType={data.eventType} />
          )}
        </Box>
      </Box>
      {openEventDetails && (
        <EventDetailsPopup
          id={data.id}
          open={openEventDetails}
          setOpen={setOpenEventDetails}
        />
      )}

    </Box>
  )
}
